module.exports = __webpack_public_path__ + "static/media/Screenshot 2026-03-21 at 12.21.18.2b8a0ba8.png";